const STORAGE_KEY = 'Antbuildz-Panel';


const callMiddlewares = state => {
    // MIDDLEWARES
}


export const saveState = (mainstate) => {


    // console.log("saveState")
    // console.log(JSON.stringify(mainstate))
    // let seen = [];

    let stringif = {}

    for (const [key, value] of Object.entries(mainstate)) {
        if (key == 'settings') {
            stringif[key] = {}
            for (const [mkey, mvalue] of Object.entries(value)) {
                if (mkey != 'titleButtons') {
                    stringif[key][mkey] = mvalue

                }
            }
        } else {
            stringif[key] = value
        }
    }

    // let stringif = JSON.stringify(mainstate, function(key, val) {
    //     if (val != null && typeof val == "object") {
    //          if (seen.indexOf(val) >= 0) {
    //              return;
    //          }
    //          seen.push(val);
    //      }
    //      return val;
    //  });

    //  JSON.parse(stringif)

    // console.log(stringif)
    try {
        let state = stringif
        if (state?.settings?.titleButtons) {
            delete state.settings.titleButtons
        }

        let stateFilter = JSON.parse(JSON.stringify(state))
        if (state?.settings?.titleButtons) {
            delete state.settings.titleButtons
        }
        const rawState = JSON.stringify(stateFilter);
        localStorage.setItem(STORAGE_KEY, rawState);

    } catch (err) {
        console.log(err)
    }
};


export const persistedState = (() => {
    try {
        const rawState = localStorage.getItem(STORAGE_KEY);
        console.log(rawState)
        if (rawState === null) return undefined;
        const state = JSON.parse(rawState);
        delete state.resource
        delete state.notifs
        // delete state.settings


        callMiddlewares(state);
        return state;
    } catch (err) {
        return undefined;
    }
})()